// API /////////////////////////////////
export const LandingMessageUrl = (): string => '/ClubLink/GetMessageData';
export const BranchBaseInfoUrl = (): string => '/ClubLink/GetBranchBaseInfo';

export const LandingUrl = (): string => '/ClubLink/Landing';
